export const NavigationalWarningServiceData = {
  data: [
    {
      title: '渤海北部军事任务--辽航警178/24',
      type: '军事任务',
      source: '中国海事局',
      content:
        ' <p>     辽航警178/24，渤海北部，自<font color="#f00000">6月19日1800时至20日0300时</font>     在40-23.57N120-48.87E、40-23.70N120-55.93E、40-17.98N120-56.17E和40-17.93N120-48.63E诸点连线范围内进行军事演习。<font color="#f00000">禁止驶入。</font> </p> ',
      expires_time_conv: '2024-06-20 04:00',
      pub_time_conv: '2024-06-18 20:47',
      points_conv:
        '40.392833,120.8145,40.395,120.932167,40.299667,120.936167,40.298833,120.8105',
      point_type: '面',
    },
    {
      title: '军事任务——辽航警175/24',
      type: '军事任务',
      source: '中国海事局',
      content:
        ' <p>     辽航警175/24，渤海海峡黄海北部，自<font color="#f00000">6月16日1600时至23日1600时</font>     在38-51.7N121-38.2E、38-34.2N121-38.2E、38-33.9N121-07.9E、38-48.2N121-14.1E诸点连线范围内执行军事任务。<font color="#f00000">禁止驶入。</font> </p> ',
      expires_time_conv: '2024-06-23 17:00',
      pub_time_conv: '2024-06-14 10:06',
      points_conv:
        '38.861667,121.636667,38.57,121.636667,38.565,121.131667,38.803333,121.235',
      point_type: '面',
    },
    {
      title: '冀航警358/24 军事任务',
      type: '军事任务',
      source: '中国海事局',
      content:
        ' <p>     冀航警358/24，渤海，<font color="#f00000">6月15日1800时至21日0000时</font>     在下列四点连线海域范围内执行军事任务: </p> \n\n<p style="margin-left:31.9pt;">(1)39-40.00N 119-10.00E；(2)39-40.00N 120-06.00E；</p> \n\n<p style="margin-left:31.9pt;">(3)39-10.00N 120-06.00E；（4）39-10.00N 119-10.00E。</p> \n\n <p>     <font color="#f00000">禁止驶入。</font> </p> ',
      expires_time_conv: '2024-06-22 00:00',
      pub_time_conv: '2024-06-13 10:37',
      points_conv:
        '39.666667,119.166667,39.666667,120.1,39.166667,120.1,39.166667,119.166667',
      point_type: '面',
    },
    {
      title: '军事任务——辽航警172/24',
      type: '军事任务',
      source: '中国海事局',
      content:
        ' <p>     辽航警172/24，渤海，自<font color="#f00000">6月13日0800时至27日1200时</font>     在39-51.0N119-53.7E、39-51.0N120-36.3E、39-19.0N120-36.3E、39-19.0N119-53.7E诸点连线范围内执行军事任务。<font color="#f00000">禁止驶入。</font> </p> ',
      expires_time_conv: '2024-06-27 13:00',
      pub_time_conv: '2024-06-12 15:01',
      points_conv:
        '39.85,119.895,39.85,120.605,39.316667,120.605,39.316667,119.895',
      point_type: '面',
    },
  ],
  status: 0,
  msg: '',
}
